module.exports = __webpack_public_path__ + "static/media/most-active-month-video.590e2094.mp4";